import * as React from 'react';

/**
 * The component return checkmark icon
 * @return {React.ReactElement}
 * @constructor
 */
export default function Invite(): React.ReactElement {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.5611 23.8964C17.6464 25.9817 21.0273 25.9817 23.1127 23.8964C25.198 21.811 25.198 18.4301 23.1127 16.3448C21.0273 14.2594 17.6464 14.2594 15.5611 16.3448C13.4757 18.4301 13.4757 21.811 15.5611 23.8964ZM18.8537 20.7403V23.1038H19.8261V20.7403H22.3353V19.6985H19.8261V17.3469H18.8537V19.6985H16.3385V20.7403H18.8537Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M11.0938 10.8349C13.9361 10.8349 16.2402 8.53082 16.2402 5.68858C16.2402 2.84633 13.9361 0.542236 11.0938 0.542236C8.25157 0.542236 5.94748 2.84633 5.94748 5.68858C5.94748 8.53082 8.25157 10.8349 11.0938 10.8349ZM11.0926 12.3068C5.82277 12.3068 1.53516 16.5944 1.53516 21.8642C1.53516 22.2701 1.86454 22.5995 2.27037 22.5995H12.6603C11.7232 20.0711 12.2704 17.1174 14.3019 15.0859C14.8565 14.5313 15.4798 14.0873 16.1445 13.754C14.6779 12.8371 12.946 12.3068 11.0926 12.3068Z" />
    </svg>
  );
}

